import { InferType, object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object({
  phone: string().required(),
})

export type SuccessfulResponse = { valid: boolean }

export type Request = InferType<typeof Schema>

export const url = () => `/v1/validate/phone`

export const getBody = ({ phone }: Request) => ({ phone })
